export default __webpack_public_path__ + "static/media/dispensary-illustration.08330faf.svg";